import type { TFunction } from "i18next";

import type { IButtonVariantsData } from "@components/atoms/button";
import { Icon } from "@components/atoms/icons";

export const VButtonVariants = (
  t: TFunction<"actions">,
): IButtonVariantsData => ({
  default: {},
  main: { color: "primary" },
  secondary: { color: "danger", variant: "outlined" },
  "danger-main": { color: "danger" },
  "danger-secondary": { color: "danger", variant: "outlined" },
  cancel: {
    color: "danger",
    variant: "outlined",
    type: "button",
  },
  submit: {
    color: "primary",
    type: "submit",
  },
  action: { variant: "transparent" },
  add: {
    variant: "transparent",
    type: "button",
    label: "افزودن به لیست موجود",
    icon: <Icon name={"AddSquare"} />,
  },
  select: { variant: "transparent", type: "button", label: "Select" },
  "edit-add": {
    variant: "contained",
    color: "primary",
    label: t("addAndEdit"),
    icon: <Icon name={"PenNewSquare"} />,
  },
});
